import styled from 'styled-components';

import BodyTextBlock from '@carvana/showroom-content/TextBlock/Body';
import { getMediaQuery } from '@carvana/showroom-theme';

export const StyledSummary = styled(BodyTextBlock)`
  font-size: 0.875rem;
  line-height: 20px;
  border-bottom: 1px solid ${({ theme }) => theme.carvana.gray.light};

  padding: 0 1rem 2rem 1rem;

  ${(props) => getMediaQuery(props.theme.breakpoint.md)} {
    padding: 0 1.625rem 2rem 1.625rem;
  }
`;
